import React, { createContext, useState, useEffect } from 'react';
import { api } from './api';

const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [books, setBooks] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [booksLoading, setBooksLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [error, setError] = useState(null);

    const fetchBooks = async (page = 1, query = '') => {
        setBooksLoading(true);
        setError(null);
        try {
            let url = `/books?page=${page}`;
            if (query.trim()) {
                url += `&keyword=${encodeURIComponent(query.trim())}`;
            }
            const response = await api.get(url);
            
            if (response.status === 200) {
                setBooks(response.data.data || []);
                setTotalPages(response.data.last_page || 1);
                setCurrentPage(response.data.current_page || 1);
                setSearchQuery(query);
            } else {
                throw new Error('Failed to fetch books');
            }
        } catch (error) {
            console.error("Error fetching books:", error);
            setError(error.response?.data?.message || 'Failed to fetch books');
            setBooks([]);
        } finally {
            setBooksLoading(false);
        }
    };

    // Initial fetch
    useEffect(() => {
        fetchBooks(1, '');
    }, []);

    return (
        <UserContext.Provider value={{
            books,
            totalPages,
            currentPage,
            booksLoading,
            searchQuery,
            error,
            fetchBooks,
            setSearchQuery,
        }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserProvider, UserContext };

